import { render, staticRenderFns } from "./LoginScreen.vue?vue&type=template&id=5aa7cfbd"
import script from "./LoginScreen.vue?vue&type=script&lang=js"
export * from "./LoginScreen.vue?vue&type=script&lang=js"
import style0 from "./LoginScreen.vue?vue&type=style&index=0&id=5aa7cfbd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports